import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
    name: 'search',
    initialState: {
        term: '',
    },
    reducers: {
        UpdateSearchTerm: (state, action) => {
            state.term = action.payload;
        },
    },
});

export const { UpdateSearchTerm } = searchSlice.actions;
export default searchSlice.reducer;
